import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const problems = [{
  tag: '😩 Problem #1',
  title: '“I’m bored!” — over and over',
  text: 'Even with a room full of toys. Even right after you buy something new. The boredom cycle never ends, and you are running out of ideas.',
  img: 'https://cdn.magicpatterns.com/uploads/ihjE7DKY1ufhoEJhsEe429/IMG_1064.webp',
  alt: 'Crying young child beside toys',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}, {
  tag: '📱 Problem #2',
  title: 'Screens. All day. Every day.',
  text: 'You give them a tablet “just for a minute,” and two hours later they are still glued to it. Nothing captures them like a screen — and you hate it.',
  img: 'https://cdn.magicpatterns.com/uploads/iF8QAP4AAhfEAASdSCwhT5/IMG_1063.webp',
  alt: 'Frustrated boy staring at a tablet',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '😤 Problem #3',
  title: 'You have tried everything — nothing sticks',
  text: 'Craft kits, puzzles, outdoor activities… they last an afternoon. You keep spending money and energy, yet nothing holds their attention for more than a day.',
  img: 'https://cdn.magicpatterns.com/uploads/wLtfrSPqS9mi15yuLtP3pw/IMG_1062.webp',
  alt: 'Two boys hiding behind their phones',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '😭 Problem #4',
  title: 'The meltdown when the screen goes away',
  text: 'Every time you limit screen time, it turns into a battle. Tears, tantrums, bargaining. You feel like the bad guy, even though you only want what is best for them.',
  img: 'https://cdn.magicpatterns.com/uploads/by9pMNhj1jGZXhdizermvD/IMG_1065.webp',
  alt: 'Crying girl beside a teddy bear',
  tone: 'bg-brand-light',
  tagTone: 'bg-brand/15 text-brand'
}];
export function Problems() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-143" data-mp="f3421dls6pbk">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-144" data-mp="oy1jjtay053f">
        <SectionHeading eyebrow="Does this sound familiar?" title="Do you know this feeling?" subtitle="Every parent knows it. You want your kids off screens and engaged in something real — but nothing seems to hold their attention for long." data-id="element-145" data-mp="ovfdxz7m3znu" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-146" data-mp="ax8mp1x64xx5">
          {problems.map((p, i) => <motion.article key={p.tag} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${p.tone}`} data-id="element-147" data-mp="608hsuc2217m" data-mpi={i}>
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-148" data-mp="34bbraow4lidl">
                <img src={p.img} alt={p.alt} className="h-full w-full object-cover" data-id="element-149" data-mp="399n14zmf7svt" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-150" data-mp="3e6n7lbn6mxng">
                <span className={`mb-3 w-fit rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${p.tagTone}`} data-id="element-151" data-mp="3j6rqf8bkc4gu">
                  {p.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-152" data-mp="2qivuw6xqciln">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-153" data-mp="2vh76on7l536i">
                  {p.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}